import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, n = /* @__PURE__ */ o("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M7.501 5.833c.01-1.812.091-2.794.731-3.434.733-.732 1.911-.732 4.268-.732h.833c2.358 0 3.536 0 4.269.732.731.732.731 1.911.731 4.268v6.666c0 2.357 0 3.536-.731 4.268-.734.732-1.911.732-4.269.732H12.5c-2.357 0-3.535 0-4.268-.732-.64-.64-.72-1.622-.73-3.434"
}, null, -1), c = /* @__PURE__ */ o("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M12.5 10H1.666m0 0 2.917-2.5M1.666 10l2.917 2.5"
}, null, -1), s = [
  n,
  c
];
function l(d, i) {
  return e(), t("svg", r, [...s]);
}
const u = { render: l };
export {
  u as default,
  l as render
};
